export default {"src":"/_next/static/media/tag-chef.dddf2467.svg","height":20,"width":26,"blurWidth":0,"blurHeight":0};